<div class="main-container" *ngIf="!isDataLoading">
	<h3>Workforce Asset Report Request</h3>
	<h5>{{assetDetails?.resourceType}} - {{assetDetails?.name}}</h5>
	<div class="main-form">
		<ng-container *ngIf="!onDemandDates.length">
			<p class="email-not-found">
				There are no Completed On Demand Digital Log Forms for the given Id.
			</p>
		</ng-container>

		<ng-container *ngIf="onDemandDates.length">
			<form [formGroup]="reportFormGroup" (keyup)="keyPressed($event)" class="main-form">
				<mat-radio-group formControlName="date" class="dates-list">
					<mat-radio-button class="example-radio-button" *ngFor="let date of onDemandDates" [value]="date">
						{{date}}
					</mat-radio-button>
				</mat-radio-group>
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput formControlName="email" [disabled]="isDataLoading" autocomplete="on" name="email" />
				</mat-form-field>

				<p *ngIf="isEmailInvalid" class="email-not-found warning">This email is not allowed to access the
					specified
					report!</p>

				<p *ngIf="isRequestSent" class="email-not-found">Request successfully submitted!</p>

				<div class="form-button-container">
					<button mat-raised-button type="button" (click)="checkEmail()"
						[disabled]="reportFormGroup.invalid || isDataLoading || isRequestSent || isEmailInvalid">Request
						Report</button>
				</div>
			</form>
		</ng-container>
	</div>
</div>

<app-loader [isInline]="true" *ngIf="isDataLoading"></app-loader>